import api from '@/core/apiclient'
import {actionTypes} from '@/core/constants'

export default {

    async [actionTypes.CADASTROS.PACIENTE.FICHA.CADASTRAR_FICHA](context, dados) {
        const {data} = await api.ficha.cadastrar(dados)
        return data
    },

    async [actionTypes.CADASTROS.PACIENTE.FICHA.EDITAR_FICHA](context, dados) {
        const {data} = await api.ficha.editarFichaPaciente(dados)
        return data
    },

    async [actionTypes.CADASTROS.PACIENTE.FICHA.BUSCAR_POR_PACIENTE](context, id) {
        const {data} = await api.ficha.buscarPorPaciente(id)
        return data
    },

}